export enum FeatureName {
  MAINTENANCE = 'maintenance',
  RENTALS = 'rentals',
  CAMPAIGN = 'campaign',
  DCL_CONTROLLER_V2 = 'dcl-controller-v2',
  NEW_NAVBAR_DROPDOWN = 'new-navbar-dropdown',
  EMOTES_V2 = 'emotes-2.0',
  SMART_ITEMS = 'smart-items',
  WORLDS_FOR_ENS_OWNERS = 'worlds-for-ens-owners'
}
